import script from "./CollapsiblePropertyConnection.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertyConnection.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertyConnection.vue?vue&type=style&index=0&id=7246a700&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7246a700"]])

export default __exports__